<template>
  <div
    v-if="hasPagination"
    class="store-pagination"
  >
    <div
      v-if="!pagination.viewAll"
      class="store-pagination__inner"
    >
      <button
        type="button"
        class="store-pagination__nav"
        :disabled="pagination.page === 1"
        @click="prevPage"
      >
        <svg
          data-icon="arrow"
          aria-hidden="true"
          viewBox="0 0 14 11"
          style="transform: rotate(180deg)"
        >
          <use xlink:href="/resources/app/client/dist/spritemap.svg#sprite-arrow" />
        </svg>
        <span>Previous</span>
      </button>

      <div class="store-pagination__chooser">
        <select
          @change="setPage($event.target.value)"
        >
          <option
            v-for="page in pages"
            :key="page"
            :value="page"
            :selected="pagination.page === page"
          >
            {{ page }}
          </option>
        </select>

        of {{ totalPages }}
      </div>

      <button
        type="button"
        class="store-pagination__nav"
        :disabled="pagination.page === totalPages"
        @click="nextPage"
      >
        <span>Next</span>
        <svg
          data-icon="arrow"
          aria-hidden="true"
          viewBox="0 0 14 11"
        >
          <use xlink:href="/resources/app/client/dist/spritemap.svg#sprite-arrow" />
        </svg>
      </button>
    </div>

    <div
      class="store-pagination__view"
      :class="{ 'store-pagination__view--active': pagination.viewAll }"
    >
      <button
        type="button"
        class="store-pagination__view-all"
        @click="toggleViewAll"
      >
        <span v-if="!pagination.viewAll">
          View All
        </span>

        <span v-if="pagination.viewAll">
          Show Fewer
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Pagination',

  computed: {
    ...mapState([
      'pagination'
    ]),

    totalPages () {
      return Math.ceil(this.pagination.total / this.pagination.limit)
    },

    pages () {
      return Array.from({ length: this.totalPages }, (_, i) => i + 1)
    },

    hasPagination () {
      return this.totalPages > 1
    }
  },

  methods: {
    ...mapMutations([
      'prevPage',
      'nextPage',
      'setPage',
      'toggleViewAll'
    ])
  }
}
</script>
